import {useEffect, useState} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {Link} from "@mui/material"
import {Trans, useTranslation} from "react-i18next"

import {SettlementOffer} from "./SettlementOffer"

import {paymentAPI} from "@indebted/api/paymentAPI"
import {useAnalytics} from "@indebted/analytics"
import {colors} from "@indebted/theme/colors"

function SettlementInFullOptionLink({
	RequiresAffordabilityAssessment,
	DiscountPercentage,
	OutstandingBalanceWithDiscount,
	Currency,
	DiscountValue,
	ExpireDate,
}: {
	RequiresAffordabilityAssessment: boolean
	DiscountPercentage: string
	OutstandingBalanceWithDiscount: number
	DiscountValue: number
	ExpireDate: string
	Currency: string
}) {
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	const navigate = useNavigate()
	const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null)

	const {t, i18n} = useTranslation()
	useEffect(() => {
		paymentAPI.getDefaultPaymentMethod({secureCode: secureCode!}).then((result: any) => {
			setDefaultPaymentMethod(result.DefaultPaymentMethod)
		})
	}, [secureCode])

	const redirect = (RequiresAffordabilityAssessment: boolean) => {
		if (RequiresAffordabilityAssessment) {
			navigate(`/${secureCode}/affordability-assessment/payment-in-full/initiate`)
		} else {
			navigate(`/${secureCode}/payment-in-full/${defaultPaymentMethod}`)
		}
	}

	const TermsOfDiscountOffer = (
		<>
			<Trans
				i18nKey="customer_get.outstanding_balance.settlement_offer.valid_through"
				values={{
					Date: new Date(ExpireDate).toLocaleDateString(i18n.language, {
						year: "numeric",
						month: "long",
						day: "numeric",
					}),
				}}
				components={{bold: <strong />}}
			/>
			<Link
				href={t("customer_get.outstanding_balance.settlement_offer.discount.terms_and_conditions.url")}
				target="_blank"
				rel="noreferrer noopener"
				color={colors.blue["700"]}
			>
				{" "}
				{t("customer_get.outstanding_balance.settlement_offer.discount.terms_and_conditions.label")}
			</Link>
		</>
	)

	return (
		<SettlementOffer
			HeaderDescription={t("customer_get.outstanding_balance.settlement_offer.pay_in_full_with_discount")}
			HeaderDiscount={t("customer_get.outstanding_balance.settlement_offer.discount_off", {
				Discount: DiscountPercentage,
			})}
			BalanceToPay={t("customer_get.outstanding_balance.settlement_offer.balance_to_pay")}
			OutstandingBalanceWithDiscountValue={t("customer_get.outstanding_balance.outstanding_balance_value", {
				OutstandingBalanceValue: OutstandingBalanceWithDiscount / 100,
				formatParams: {OutstandingBalanceValue: {currency: Currency}},
			})}
			SaveDiscountValue={t("customer_get.outstanding_balance.settlement_offer.save_discount_value", {
				DiscountValue: DiscountValue / 100,
				formatParams: {DiscountValue: {currency: Currency}},
			})}
			ButtonLabel={t("customer_get.outstanding_balance.settlement_offer.pay_with_discount", {
				Discount: DiscountPercentage,
			})}
			Footnote={t("customer_get.outstanding_balance.settlementplan.footnote")}
			ShowFootnote={false}
			TermsOfDiscountOffer={TermsOfDiscountOffer}
			onClick={() => {
				track("PIFButtonClicked", {SecureCode: secureCode})
				redirect(RequiresAffordabilityAssessment)
			}}
		/>
	)
}
export {SettlementInFullOptionLink}
